// extracted by mini-css-extract-plugin
export default {"relatedProperties":"mobile-related-properties_relatedProperties__qvm-x","title":"mobile-related-properties_title__be860"};